<template>
  <div class="add-scale" id="add-scale">
    <div class="box2">
      <el-button type="danger" round style="" @click="goBack" class="back"
        >返回</el-button
      >
      <h1>{{ scaleData.name }}</h1>
      <div class="top-content" v-for="(topic, index) in topicList" :key="index">
        <div v-if="index == page" class="topicTitle">
          <!-- 题干 -->
          <div class="flex">
            <span style="margin-right: 10px">{{ index + 1 + '.' }} </span>
            <el-input
              v-model="topic.title"
              placeholder="请输入题干"
              style="width: 600px"
              type="textarea"
              autosize
            ></el-input>
          </div>
          <!-- 题目 -->
          <div>
            <div v-for="(smallTopic, i) in topic.content" :key="i">
              <div class="smallTopic">
                <div class="flex">
                  <span style="margin-right: 10px"
                    >{{ '(' + (i + 1) + ')' + '.' }}
                  </span>
                  题目类型：
                  <el-select v-model="smallTopic.type" placeholder="请选择">
                    <el-option
                      v-for="item in topicOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    style="margin: 0 10px"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="deteleRow(index, i)"
                  ></el-button>
                  <!-- <span> 答案： 第 &nbsp</span>
                  <el-select
                    v-model="smallTopic.answer"
                    placeholder="请选择"
                    style="width: 100px"
                  >
                    <el-option
                      v-for="item in 20"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <span> &nbsp项</span> -->
                </div>
                <div>
                  <singleSelect
                    :index="index"
                    :i="i"
                    :smallTopic="smallTopic"
                    v-if="
                      smallTopic.type === '单选题' ||
                      smallTopic.type === '多选题'
                    "
                    @addOptins="addOptins"
                  ></singleSelect>

                  <shortAnswer
                    :smallTopic="smallTopic"
                    v-if="smallTopic.type === '简答题'"
                  >
                  </shortAnswer>
                </div>
              </div>
            </div>
          </div>
          <!-- 加号 -->
          <div class="plus-box">
            <el-button
              type="primary"
              icon="el-icon-plus"
              circle
              @click="addRow(index)"
            ></el-button>
          </div>

          <div class="btn">
            <el-button v-if="index > 0" @click="topPage(index)"
              >上一页</el-button
            >
            <el-button @click="nextPage(index)">下一页</el-button>
            <el-button type="danger" @click="normal(index)">保存</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import singleSelect from './components/singleSelect';
import shortAnswer from './components/shortAnswer';
import { scalePage, scale } from './api/index.js';

export default {
  name: 'add-scale',
  components: {
    singleSelect,
    shortAnswer
  },

  props: {},
  data() {
    return {
      scaleData: this.$route.query,
      topicList: [
        {
          title: '',
          content: []
        }
      ],
      topicOptions: [
        {
          label: '单选题'
        },
        {
          label: '多选题'
        },
        {
          label: '简答题'
        }
      ],
      page: 0,
      pageId: null
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    // 加一行
    addRow(index) {
      console.log(index);
      let secondItem = this.topicList[index];
      if (!secondItem.hasOwnProperty('content')) {
        this.$set(secondItem, 'content', []);
      }
      this.$set(secondItem.content, secondItem.content.length, {
        type: '',
        topicName: '',
        topicOptions: [],
        answer: ''
      });
    },
    // 上一页
    topPage(index) {
      console.log(index);
      index--;
      this.page--;
    },
    // 下一页
    nextPage(index) {
      this.topicList.push({
        title: '' // 题干
      });
      console.log(index);
      index++;
      this.page++;
    },

    async getWebIds() {
      const saveWebApis = async (prm, i) =>
        await scalePage.add({
          name: prm.title,
          ownershipId: this.scaleData.id,
          orderBy: i + 1
        });
      return new Promise(async (resolve) => {
        const res = await Promise.all(
          this.topicList.map((item, i) => saveWebApis(item, i))
        );
        resolve(res);
      });
    },
    // 保存
    async normal() {
      const submitApi = async (obj, index) => {
        let params2 = {
          type: obj.type,
          orderBy: index + 1,
          pageId: this.pageId,
          scaleOptions: this.optionSort(obj.topicOptions),
          ownershipId: this.scaleData.id,
          stem: obj.topicName,
          answer: obj.answer
        };
        await scale.add(params2);
      };
      if (!this.topicList[0].title) return;
      for (let i = 0; i < this.topicList.length; i++) {
        const item = this.topicList[i];
        let params1 = {
          name: item.title,
          ownershipId: this.scaleData.id,
          orderBy: i + 1
        };

        scalePage.add(params1).then((res) => {
          this.pageId = res.data;
          Promise.all(
            item.content.map((obj, index) => {
              submitApi(obj, index);
            })
          ).then((_) => {
            this.$message.success('保存成功');
            this.goBack();
          });
        });
      }
    },
    // 增加每一题的选项
    addOptins(i1, i2) {
      this.topicList[i1].content[i2].topicOptions.push({
        options: '',
        orderBy: null
      });
    },
    // 删除某一题
    deteleRow(i1, i2) {
      this.$delete(this.topicList[i1].content, i2);
    },
    // 回退
    goBack() {
      this.$router.push('scale');
    },
    // 选项排序
    optionSort(item) {
      return item.map((item, index) => {
        return { ...item, orderBy: index + 1 };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-scale {
  background-image: url('~@/assets/appraisal.png'); // 设置背景图片
  background-attachment: fixed;
  background-position: center;
  // background-size: 100% 100%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: hidden;

  .box2 {
    width: 800px;
    // height: 850px;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 40px;
    line-height: 30px;
    text-align: center;
    overflow: auto;
    position: relative;
    padding-bottom: 100px;
    .back {
      position: absolute;
      top: 30px;
      left: 30px;
    }
    .top-content {
      margin-top: 20px;
      float: left;

      .plus-box {
        margin-left: 40px;
        margin-top: 20px;
      }
      .topicTitle {
        margin-bottom: 20px;
      }
      .smallTopic {
        margin: 20px;
      }
    }
    .btn {
      height: 50px;
      text-align: center;
      position: fixed;
      top: 90%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.flex {
  display: flex;
  // justify-content: center;
  align-items: center;
}

#add-scale::-webkit-scrollbar,
.digbox::-webkit-scrollbar,
.el-dialog__body::-webkit-scrollbar,
.form-scroll::-webkit-scrollbar,
.el-table--scrollable-y::-webkit-scrollbar {
  width: 3px;
  height: 0px;
}
#add-scale::-webkit-scrollbar-track,
.digbox::-webkit-scrollbar-track,
.el-dialog__body::-webkit-scrollbar-track,
.form-scroll::-webkit-scrollbar-track,
.el-table--scrollable-y::-webkit-scrollbar-track {
  background-color: transparent;
}
#add-scale::-webkit-scrollbar-thumb,
.digbox::-webkit-scrollbar-thumb,
.el-dialog__body::-webkit-scrollbar-thumb,
.form-scroll::-webkit-scrollbar-thumb,
.header::-webkit-scrollbar-thumb,
.el-table--scrollable-y::-webkit-scrollbar-thumb {
  background-color: rgba(102, 103, 104, 0.5);
}
#add-scale::-webkit-scrollbar-button,
.digbox::-webkit-scrollbar-button,
.el-dialog__body::-webkit-scrollbar-button,
.form-scroll::-webkit-scrollbar-button,
.header::-webkit-scrollbar-button,
.el-table--scrollable-y::-webkit-scrollbar-button {
  background-color: transparent;
  height: 3px;
}
#add-scale::-webkit-scrollbar-corner,
.el-dialog__body::-webkit-scrollbar-corner,
.form-scroll::-webkit-scrollbar-corner,
.header::-webkit-scrollbar-corner,
.el-table--scrollable-y::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(102, 103, 104, 0.5);
}
</style>